import { action } from 'satcheljs';
/**
 * Called when we select discard, resets the event options in store
 */
var discardEventOption = action('discardEventOption', function () { return ({}); });
export default discardEventOption;
//# sourceMappingURL=discardEventOption.js.map